import { O, pipe, R } from "@scripts/fp-ts";
import type { Event } from "@scripts/generated/models/event";
import type { EventWithRelatedContent } from "@scripts/generated/models/eventWithRelatedContent";

export const eventHasModal = (event: Event | EventWithRelatedContent): boolean =>
  "eventBlurb" in event
    ? O.isSome(event.eventBlurb)
    : O.isSome(event.event.eventBlurb) || pipe(event.relatedContent, R.some(a => a.length > 0));
